var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.4 11.4v4.4c0 .66-.54 1.2-1.2 1.2h-12A1.2 1.2 0 0 1 1 15.8v-12c0-.66.54-1.2 1.2-1.2h4.4M9 9l7.2-7.2M11.4 1H17v5.6",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgExternal;